import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Catalog from './pages/Catalog'
import ProductDetail from './pages/ProductDetail'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import Orders from './pages/Orders'
import Profile from './pages/Profile'
import Categories from './pages/Categories'
import AdminProducts from './pages/AdminProducts'
import AdminProductEdit from './pages/AdminProductEdit'
import AdminCategories from './pages/AdminCategories'
import ProductImages from './pages/ProductImages'
import { CartProvider } from './context/CartContext'
import { TelegramProvider } from './context/TelegramContext'
import './App.css'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Инициализация приложения
    const initApp = async () => {
      try {
        // Применяем тему Telegram
        if (window.Telegram?.WebApp) {
          const tg = window.Telegram.WebApp
          
          tg.ready()
          tg.expand()
          
          // Устанавливаем цвета
          if (tg.colorScheme === 'dark') {
            document.body.classList.add('dark-theme')
          }
          
          // Настраиваем заголовок
          tg.headerColor = tg.themeParams.bg_color || '#FFFFFF'
          
          // Разрешаем закрытие приложения
          tg.enableClosingConfirmation()

          // Проверяем была ли принята политика
          const privacyAccepted = sessionStorage.getItem('privacy_accepted')
          
          if (!privacyAccepted) {
            // Показываем popup согласия
            tg.showPopup({
              title: 'Условия использования',
              message: 'Открывая это мини-приложение, Вы принимаете Условия использования мини-приложений.',
              buttons: [
                { id: 'cancel', type: 'cancel', text: 'Отмена' },
                { id: 'privacy', type: 'default', text: 'Политика конфиденциальности' },
                { id: 'launch', type: 'ok', text: 'Запустить' }
              ]
            }, (buttonId) => {
              if (buttonId === 'privacy') {
                // Открываем политику конфиденциальности Telegram
                tg.openLink('https://telegram.org/privacy/ru')
                // После просмотра политики показываем popup снова
                setTimeout(() => {
                  tg.showPopup({
                    title: 'Условия использования',
                    message: 'Открывая это мини-приложение, Вы принимаете Условия использования мини-приложений.',
                    buttons: [
                      { id: 'cancel2', type: 'cancel', text: 'Отмена' },
                      { id: 'launch2', type: 'ok', text: 'Запустить' }
                    ]
                  }, (btnId) => {
                    if (btnId === 'launch2') {
                      sessionStorage.setItem('privacy_accepted', 'true')
                    } else {
                      tg.close()
                    }
                  })
                }, 500)
              } else if (buttonId === 'launch') {
                sessionStorage.setItem('privacy_accepted', 'true')
              } else {
                tg.close()
              }
            })
          }
        }
        
        setIsLoading(false)
      } catch (error) {
        console.error('Ошибка инициализации:', error)
        setIsLoading(false)
      }
    }

    initApp()
  }, [])

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    )
  }

  return (
    <Router basename="/miniapp">
      <TelegramProvider>
        <CartProvider>
          <div className="app">
            <Routes>
              <Route path="/" element={<Catalog />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/admin/categories" element={<AdminCategories />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/products/add" element={<AdminProductEdit />} />
              <Route path="/admin/products/edit/:id" element={<AdminProductEdit />} />
              <Route path="/admin/products/images/:id" element={<ProductImages />} />
            </Routes>
          </div>
        </CartProvider>
      </TelegramProvider>
    </Router>
  )
}

export default App


